module.exports = __webpack_public_path__ + "images/931ea04a9bb6e4639a1887a74f71e952.png";


//////////////////
// WEBPACK FOOTER
// ./js/components/assets/woman/5.png
// module id = 381
// module chunks = 0